import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Heading, Box, Button, Cell, Layout } from 'wix-style-react';
import { Path } from '../../../index';
import { config } from '../../../config';
import s from './holiday-sale-header.scss';
import { CounterHolidaySaleExport } from '@wix/app-market-collection-widget';
import { useConfigContext } from '../../../config-context';
import { biLogger } from '../../../bi';
export var HolidaySaleHeader = composer().compose(function (_a) {
    var t = _a.t, market = _a.market, showNewContent = _a.showNewContent;
    // tslint:disable-next-line:react-hooks-nesting
    var locale = useConfigContext().locale;
    return (React.createElement(Layout, null,
        React.createElement(Cell, { span: 8 },
            React.createElement(Title, { showNewContent: showNewContent })),
        React.createElement(Cell, { span: 4 },
            React.createElement(Box, { align: 'right' },
                React.createElement(Box, { direction: "vertical", align: 'center' },
                    React.createElement(CounterHolidaySaleExport, { locale: locale, bigDesign: true }),
                    React.createElement(CheckAllSaleAppsButton, { market: market, showNewContent: showNewContent }))))));
});
var Title = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, showNewContent = _a.showNewContent;
    var subtitleKey = showNewContent
        ? 'home.holidaySale.second-title-b'
        : 'home.holidaySale.second-title';
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { height: '12px' }),
        React.createElement(Heading, { appearance: "H2", dataHook: "holiday-title", className: s.saleTitle }, t('home.holidaySale.title')),
        React.createElement(Heading, { appearance: "H2", dataHook: "holiday-title", light: true, className: s.saleSecondTitle }, t(subtitleKey, { percentage: 50 }))));
});
var CheckAllSaleAppsButton = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, market = _a.market, marketplaceStore = _a.marketplaceStore, showNewContent = _a.showNewContent;
    var buttonCtaKey = showNewContent
        ? 'home.holidaySale.main-cta-b'
        : 'home.holidaySale.main-cta';
    return (React.createElement(Box, null,
        React.createElement(Button, { className: s.saleButton, size: 'medium', as: "button", onClick: function () {
                biLogger.appMarketSaleCheckAllSaleAppsCollectionClick({
                    market: market,
                    msid: marketplaceStore.metaSiteId,
                    sale_name: 'nov21',
                    slug_id: 'pre-holiday-sale',
                    button_location: 'top',
                });
                config.goto({
                    path: Path.CATEGORY,
                    slug: 'pre-holiday-sale',
                    referral: 'holiday-sale-home',
                });
            } }, t(buttonCtaKey))));
});
//# sourceMappingURL=holiday-sale-header.js.map